export const name = 'Carlos Abraham Hernandez';
export const links = {
  twitter: 'https://twitter.com/abranhe',
  github: 'https://github.com/abranhe',
};
export const badges = {
  github: 'https://img.shields.io/github/followers/abranhe.svg?label=Follow%20%40abranhe&style=social',
  twitter: 'https://img.shields.io/twitter/follow/abranhe.svg?style=social',
};
export const githubLink = 'https://github.com/abranhe/school';
